/*	MARK: Samantia | Simulations
	============================================
 */
/** Imports **/
import { inject, PLATFORM } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request, AuthRequest } from '../services/data-service';
import { Api } from '../services/api';
import { MachineStatus, MachineSignal } from './machine-schemas';
import { ZSC, Sammy, SammyLight } from './palette';
import Plotly from 'plotly.js-dist-min';

// Option menu
import { NavOptionMenu } from './nav-option-menu';

// Events
import { EventAggregator } from 'aurelia-event-aggregator';
import { NotificationEvent } from './notification'


const ObjectID = require('bson-objectid');

const Stages = {
	Upload:"Upload", Ready:"Ready",
	InProcess:"InProcess", Done:"Done"
}

@inject(DataService, Api, Router, EventAggregator)
export class MachineSimulation {
	
	/** MARK: Components methods
		=================================
	 **/
	constructor(ds, api, router, ea){
		// Services
		this.ds		= ds;
		this.api	= api;
		this.router = router;
		this.ea		= ea
		//this.ea		= ea;
		// Process status of forecast
		this.inProcess	= false;
		// Componetn variables
		this.sampleValues 	= {};
		this.data_points 	= 100;
		this.Stages			= Stages;
		this.stage			= Stages.Ready;
		// access token
		this.accessToken	= "";
		// Option menu
		this.navOptionMenu = new NavOptionMenu(ds, api, router, ea);
		
	}
	activate(params){
		this.id 	= params.id
		this.pid 	= params.pid;
	} // MachineID
	attached(){
		/*	============================================
		  	1 Get machine from dataservice
			2 Get dataset from machine.dataset(split name)
			3 Setup machine and dataset to DataService
			============================================
		*/
		this.init();

		// Subscriptions
		//this.savedPredictionSubs = this.ea.subscribe(NotificationEvent.PredictionSaved, msg => this.onSavedPrediction(msg));
		this.predictionDownloadSubs = this.ea.subscribe(NotificationEvent.PredictionDownload, msg => this.onPredictionDownload(msg));

	}
	
	init(){
		/*	============================================
		  	1 Get machine from dataservice
			2 If machine existis, procede to get dataset
			  else -> get remote machine and dataset
			3 Setup machine and dataset to DataService
			============================================
		*/
		let machine 		= this.ds.app_data.machine;
		//this.prediction_id 	= ObjectID(Date.now()).toHexString();
		if(!machine){
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				this.handleMachineResponse(response);
				// Get dataset?
				return this.getDataset(this.machine);
			})
			.then(res => {
				this.handleDatasetResponse(res);
				this.sampleValues = this.generateRangeSampleValues(this.dataset.summary.description, 100);

				// Load Archive prediction (PID) if need id
				if(this.pid){ this.loadArchive(this.pid); }
			});
			
		}
		else{
			
			this.machine = machine;
			this.ds.app_data.machine = machine;
			this.getDataset(machine).then(res => {
				this.handleDatasetResponse(res);
				this.sampleValues = this.generateRangeSampleValues(this.dataset.summary.description, 100);

				// Load Archive prediction (PID) if need id
				if(this.pid){ this.loadArchive(this.pid) }
			});
		}

		// -- test block ---//
		//console.log(this.router.currentInstruction);
		// --- end test block ---//
	}


	detached(){ this.predictionDownloadSubs.dispose();}

	/** Init Archive ***/
	loadArchive(pid){
		// Change Stage status (in process)
		this.stage = Stages.InProcess;

		// Load remote data
		this.getPrediction(pid).then(response => {
			this.handleGetPrediction(response);
		});
	}

	/** API Calls
		============================================
	**/

	getPrediction(pid){
		let id			= this.machine._id;
		let request 	= new Request("/api/v2/machines/"+id+"/predictions/"+pid, "GET");
		return this.api.get(request);
	}

	handleGetPrediction(response){
		// Display prediction
		if(response.status === 200){
			this.stage	= Stages.Done;
			let data	= response.data;
			// To DataService
			// To Data service
			data.credentials			= {
				uid		:this.machine.uid,
				muid	:this.machine._id,
				type	:"Simulation"
			}
			this.ds.app_data.prediction = data
			// End data Service
			// Plot
			window.setTimeout( () => { this.plotPrediction(this.machine, data);}, 1);
		}
	}

	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;
		if(status === 200){
			let machine  = response.data;
			machine.features = machine.features
			this.machine = machine
			this.ds.app_data.machine = machine;
		};
	}


	// machine.quota => 
	requestSimulationQuota(machine){
		// Auth Request
		let subsToken		= this.ds.user.subs;
		let uid				= machine.uid;
		let request			= new AuthRequest("/api/v2/users/"+uid+"/usage-token", "POST");
		let machine_quota 	= { quota: machine.quota } // prediction
		// Add body
		let body			= { machine_quota:machine_quota, uid:machine.uid };
		request.body		= JSON.stringify(body);
		// Add subs header
		request.headers["Authorization"] = "Bearer " + subsToken; // Bearer + token
		return this.api.post(request);
	}
	
	/*	Dataset calls
		============================================
	 */

	getDataset(machine){
		let request		= new Request("/api/v2/datasets/id/_id?", "GET")
		let id			= machine.dataset.split("-")[0];
		let params		= new URLSearchParams({_id:id});
		request.url		= request.url + params;
		return this.api.get(request);
	}

	handleDatasetResponse(response){
		let status = response.status;
		if(status === 200){
			let dataset 	= response.data;
			this.dataset 	= dataset;
			this.ds.app_data.dataset = dataset;
		}
	}

	/*	Simulations
		============================================
	*/
	postSimulation(machine, synthetic_params, data_points){
		let id			= machine._id;
		let request 	= new Request("/api/v2/machines/" + id + "/simulation/", "POST");
		let body		= { oper:"simulation", machine:machine,
							synthetic_params:synthetic_params,
							data_points			: data_points
						  };
		request.body 	= JSON.stringify(body)

		// Add Auth token
		request.headers["Authorization"] = "Bearer " + this.accessToken; // Bearer + token

		return this.api.post(request);
	}

	handlePostSimulation(response){
		// Handle response
		//console.log("handle post sim => ", response);
		
		let code	= response.code;
		if(code === 200){
			this.stage	= Stages.Done;
			let data	= response.data;
			
			//data._id 	= this.prediction_id;
			data._id	= (this.pid) ? this.pid : ObjectID(Date.now()).toHexString();
			// To Data service
			data.credentials			= {
				uid		:this.machine.uid,
				muid	:this.machine._id,
				type	:"Simulation"
			}
			this.ds.app_data.prediction = data
			
			window.setTimeout( () => { this.plotPrediction(this.machine, data);}, 1);
		}
		else {

			this.ea.publish(NotificationEvent.SysError, { body:response.message });
			this.stage	= Stages.Ready;
		}
	}

	/** Custom methods
		============================================
	**/

	_run_simulation(sample, data_points){
		// Change state
		this.stage 			= Stages.InProcess;
		// sample vector, data_points
		let dpoints 		= parseInt(data_points);
		let keys 			= this.machine.features // Object.keys(sample)
		let sample_vector	= []
		keys.forEach(key => {
			let val = parseFloat(sample[key].value);
			sample_vector.push(val);
		});

		this.postSimulation(this.machine, sample_vector, dpoints).then(res => {
			this.handlePostSimulation(res);
		});
	}

	run_simulation(sample, data_points){
		// Change state
		this.stage 			= Stages.InProcess;
		// sample vector, data_points
		let dpoints 		= parseInt(data_points);
		let keys 			= this.machine.features // Object.keys(sample)
		let sample_vector	= []
		keys.forEach(key => {
			let val = parseFloat(sample[key].value);
			sample_vector.push(val);
		});

		let machine_quota 	= { ... this.machine };
		machine_quota.quota = data_points;
		this.requestSimulationQuota(machine_quota).then(responseQuota => {
			let status = responseQuota.status;
			if(status === 200){
				this.accessToken = responseQuota.data.oper_token;
				// Prepare again
				sample_vector	= []
				keys.forEach(key => {
					let val = parseFloat(sample[key].value);
					sample_vector.push(val);
				});

				return this.postSimulation(this.machine, sample_vector, dpoints);
			}
			else{
				// Send message
				// return { status:404 };
				return responseQuota;
			}
		})
		.then(res => {
			//console.log("handle => ", res);
			this.handlePostSimulation(res);
		});
	}

	/*	Plots
		============================================
	 */
	display_summary_data(res_data){
		let features 	= this.machine.features;
		let output		= this.machine.y_label;
		//features.unshift(output);
		this.summary_data = {
			headers : features,
			output	: output,
			records	: [
				{ max:res_data.max, max_datapoint:res_data.max_datapoint },
				{ max:res_data.min, max_datapoint:res_data.min_datapoint },
			],
			
		}
	}

	display_tabular_data(res_data){
		// let records = res_data.sample;
		let records	= res_data.sample.map( (x) => x);
		records.unshift(res_data.prediction)
		let tabular_data = {
			headers	: this.machine.features,
			output 	: this.machine.y_label,
			records : records,
		}
		this.tabular_data = tabular_data;
	}
	
	plotPrediction(machine, res_data){
		let X	 	= [];
		for(let i=0;i < res_data.prediction.length; i++){X.push(i);}
		//let data 	= { x:X, y: res_data.prediction };

		let trace 	= {
			x	:X,
			y	:res_data.prediction,
			mode:"markers",
			name:machine.y_label,
			marker:{ color:Sammy.Lisa , size:6, opacity:0.7 }
			// ZSC.SynthPurple3
		}

		let layout = {
			title		: machine.name + " predictions",
			showlegend 	: true,
			yaxis		:{ title: {text:machine.y_label} },
			borderRadius:"10px",
			plot_bgcolor: SammyLight.Gray,
			paper_bgcolor: SammyLight.Gray,
		}
		let plot_data = [ trace ];
		Plotly.newPlot(
			this.board, plot_data, layout,
			{displaylogo:false, responsive:true, scrollZoom:true}
		);
		// Display tabular data
		this.display_summary_data(res_data);
		this.display_tabular_data(res_data);
	}

	/** Component Events
		============================================
	 **/

	// Sample values
	toFixed = (n, fixed) => ~~(Math.pow(10, fixed) * n) / Math.pow(10, fixed);

	// Generate sample
	generateRangeSampleValues(fields, range){
		/*	MARK: Genreate sample from features statistics
			============================================
		  	fields => { max, min, mean, variable_name }
			1 get max-min for every label-field
			2 divide in range the diff i.e => diff/100
			3 iterate from min plus step-diff
			4 map output to hash => return
		 */
		// Output
		let fields_map = {}
		fields.forEach((field, idx) => {
			let step = (field.max - field.min) / range;

			if(step === 0){
				step		= 0.01;
				field.max	= field.mean * 2
				field.min	= field.mean - (field.mean * 2)
			}

			
			step = this.toFixed(step, 4)
			let seq = [];
			// generate samples in length of range
			for(let i=0; i < (range - 1); i++){
				if (i === 0) { seq.push(field.min);}
				else{seq.push(seq[i-1] + step)}
			}
			// Update output map
			fields_map[field.variable] = {
				id:"field_" + idx,
				idr:"range_" + idx,
				seq:seq,
				min:field.min,
				max:field.max,
				mean:field.mean,
				step:step,
				value:field.mean
			};
		})
		return fields_map;				
	}
	
	onNumberInput(idr, val){
		let range_input 	= document.querySelector("#"+idr);
		range_input.value 	= val;
	}

	onRangeInput(id, val){
		let field_input 	= document.querySelector("#"+id);
		field_input.value 	= val;
	}

	/** MARK: Events
		=================================

	onSavedPrediction(message){
		this.show_notification = true;
		this.push_message = message;
		window.setTimeout( () => { this.show_notification = false;},5000);
	}
	**/

	toImage(){
		let image_options = { format:'png',file_name:'output', height:800, width:1024,scale:1};
		Plotly.downloadImage(this.board, image_options);
	}

	onPredictionDownload(msg){
		this.toImage();
	}
}
